export var TriggerKind;
(function (TriggerKind) {
    TriggerKind["Load"] = "load";
    TriggerKind["Scroll"] = "scroll";
    TriggerKind["Idle"] = "idle";
})(TriggerKind || (TriggerKind = {}));
//# sourceMappingURL=trigger.types.js.map